import request from '@/utils/request'

let StaffApi = {

  /*企业会员列表*/
  list(data) {
    return request._post('/shop/plus.staff.Index/index', data);
},
/*添加企业会员*/
add(data) {
    return request._post('/shop/plus.staff.Index/add', data);
},
/*修改企业会员*/
edit(data) {
    return request._post('/shop/plus.staff.Index/edit', data);
},
/*删除企业会员*/
del(data) {
    return request._post('/shop/plus.staff.Index/del', data);
},
/*企业会员详情*/
detail(data) {
  return request._post('/shop/plus.staff.Index/detail', data);
},
saveSetting(data, errorback) {
  return request._post('/shop/plus.staff.Setting/getSetting', data, errorback);
},
getSetting(data, errorback) {
  return request._get('/shop/plus.staff.Setting/getSetting', data, errorback);
},

supply(data) {
  return request._post('/shop/plus.staff.Index/supply', data);
},
/*关联企业会员到企业*/
sadd(data) {
  return request._post('/shop/plus.staff.Index/sadd', data);
},
/*修改关联企业会员到企业*/
sedit(data) {
  return request._post('/shop/plus.staff.Index/sedit', data);
},
/*删除关联企业会员到企业*/
sdel(data) {
  return request._post('/shop/plus.staff.Index/sdel', data);
},
/*关联企业会员到企业详情*/
sdetail(data) {
  return request._post('/shop/plus.staff.Index/sdetail', data);
},
getTgList(data) {
  return request._get('/shop/plus.staff.Index/getTgList', data);
},
}
export default StaffApi;



// WEBPACK FOOTER //
// ./src/api/staff.js